import {
    STEPICON_ONE,
    STEPICON_TWO,
    STEPICON_THREE,
    STEPICON_FOUR,
    BENEFIT_ONE,
    BENEFIT_TWO,
    BENEFIT_THREE,
    ARROW_IMAGE
} from './imgList';

export const CREDIT_CARD_PROTOCOL =
    'https://privacycenter.didiglobal.com/directory/MX/101839';

export const STEP_FORM_LIST = [
    {
        title: 'Completa tus datos',
        stepIcon: STEPICON_ONE,
        arrowIcon: ARROW_IMAGE
    },
    {
        title: 'Descarga la app de DiDi Finanzas',
        stepIcon: STEPICON_TWO,
        arrowIcon: ARROW_IMAGE
    },
    {
        title: 'Recibe tu tarjeta al ser aprobada',
        stepIcon: STEPICON_THREE,
        arrowIcon: ARROW_IMAGE
    },
    {
        title: 'Continúa con tu solicitud',
        stepIcon: STEPICON_FOUR,
        arrowIcon: ''
    }
];

export const BENEFIT_INFO_LIST = [
    {
        title: '2%',
        titleParts: [
            { text: 'Hasta', color: '#0C0C0D' },
            { text: '2%', color: '#ff5f14', fontSize: '0.28rem' },
            { text: 'de CASHBACK* ', color: '#0C0C0D' },
            { text: 'al pagar en ', color: '#ff5f14' },
            { text: '\n', color: '#ff5f14' },
            { text: 'DiDi', color: '#ff5f14' }
        ],
        icon: BENEFIT_ONE
    },
    {
        title: '6%',
        titleParts: [
            { text: 'Hasta ', color: '#0C0C0D' },
            { text: '6%', color: '#ff5f14', fontSize: '0.28rem' },
            { text: 'de CASHBACK* en categorías', color: '#0C0C0D' },
            { text: 'seleccionadas', color: '#ff5f14' }
        ],
        icon: BENEFIT_TWO
    },
    {
        title: '2%',
        titleParts: [
            { text: 'Hasta ', color: '#0C0C0D' },
            { text: '2%', color: '#ff5f14', fontSize: '0.28rem' },
            { text: 'de CASHBACK* al pagar en', color: '#0C0C0D' },
            { text: 'DiDi Food', color: '#ff5f14' }
        ],
        icon: BENEFIT_THREE
    }
];
